import React from 'react';
import noop from '../../util/noop';
import { ToastActionButtonElement } from './elements';
export var ToastActionButton = React.forwardRef(function (_a, fRef) {
    var id = _a.id, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.onClick, onClick = _c === void 0 ? noop : _c, _d = _a.ariaLabel, ariaLabel = _d === void 0 ? '' : _d, children = _a.children;
    return (React.createElement(ToastActionButtonElement, { ref: fRef, id: id, "aria-label": ariaLabel, className: className, onClick: onClick }, children));
});
